import axios from 'axios';
import { serverPath } from './key';
export const withoutAuth = () => {
  return axios.create({
    baseURL: `${serverPath}`,
  });
};
export const priceIntelligenceInstance = () => {
  return axios.create({
    baseURL: serverPath,
    headers: {
      userLocation: localStorage.getItem("curr_location"),
      Authorization: localStorage.getItem('fcrf@token')
        ? `${'Bearer '}${localStorage.getItem('fcrf@token')}`
        : '',
    },
    timeout: 1000 * 10000,
  });
};

export const externalApiInstance = (token) => {
  return axios.create({
    baseURL: serverPath,
    headers: {
      Authorization: `${'Bearer '}${token}`,
    },
    timeout: 1000 * 10000,
  });
};
